<template>
  <div>
    <div class="header-personal-banking">
      <div class="w-100 container-header">
        <h2>Banca Personas</h2>
        <div>
          <h3 class="ma-0">Aquí encontrarás todos las carpetas y documentos</h3>
          <h3 class="ma-0">referentes a Banca Personas</h3>
        </div>
      </div>
    </div>

    <div class="breadcrumb-container">
      <breadcrumb
        class="py-3 w-100"
        style="margin: auto; width: 100%"
        textColor="#3A399C"
      />
    </div>

    <div class="menu-container">
      <div class="menu-column" v-for="(menu, index) in personalBankingMenus" :key="index">
        <menu-item class="pr-2 text-left" :menu="menu" />
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/General/Breadcrumb";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
    };
  },
  components: {
    Breadcrumb,
    MenuItem: () => import("./MenuItem.vue"),
  },
  computed: {
    ...mapState("user", ["current_user"]),
    ...mapState("menus", ["personalBankingMenus"])
  },
  beforeMount() {
    if (typeof window !== "undefined") {
      if (!this.personalBankingMenus) {
        this.fetchPersonalBanking("null");
      }
    } else {
      console.warn("localStorage no está disponible en este contexto.");
    }
  },
  methods: {
    ...mapActions("menus", ["fetchPersonalBanking"]),
    async getPersonalBankingMenus() {
      try {
        await this.fetchPersonalBanking("null");
      } catch (error) {
        console.error("Error getting personal banking menus:", error);
      }
    },
  },
  created() {
    this.getPersonalBankingMenus();
  },
};
</script>
<style scoped>
.header-personal-banking {
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  align-content: center;
  background-color: #f4f4ff;
  padding: 1.875rem 0;
  color: #232272;
}

.header-personal-banking h2 {
  font-size: 2rem;
}

.header-personal-banking h3 {
  font-weight: 400;
}

.menu-container {
  display: flex;
  flex-wrap: wrap;
}

.menu-column {
  max-width: 300px;
  margin: 0;
  flex: 1 1 25%;
  box-sizing: border-box;
}
.text-left{
  text-align: start;
}
.container-header{
  display: flex;
  justify-content: space-between;
  margin: auto
}

.breadcrumb-container{
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  display: flex;
  background-color: #f6f6f6
}

@media (max-width: 800px) {
  .menu-column {
    flex: 1 1 50%;
  }
}

@media (max-width: 500px) {
  .menu-column {
    flex: 1 1 100%;
  }
}
</style>
